var r = /* @__PURE__ */ ((e) => (e.WILL_INFO = "will-info", e.CREATE_WILL = "create-will", e.SLC = "streamlined-lawyer-connection", e.NEW_CHAT = "new-chat", e.LAWYER_REQUEST_CHAT = "lawyer-request-chat", e))(r || {});
const a = "lawyer-request", t = (e) => {
  switch (e) {
    case "will-info":
      return "/en-us/make-a-will";
    case "create-will":
      return "/chat/diy-will?newCase";
    case "new-chat":
      return "/chat";
    case "lawyer-request-chat":
      return `/chat/${a}`;
  }
  return "/";
};
export {
  a as LAWYER_REQUEST_KEY,
  r as RouteType,
  t as getRoute
};
